import React from 'react';
import { HyperdbForm } from '../../../../hyperdb';
import { TextInput, Multilingual, DropdownSelector, CodeEditor } from 'hyperdb-utils';
import { CountrySelector } from '../../../address-book/country';
import touristTaxTypes from '../tourist-tax-types';

const MultilingualField = Multilingual(TextInput);

class Form extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const touristTaxParameters = this.props.objectData.tourist_tax_parameters && typeof this.props.objectData.tourist_tax_parameters === 'object'
      ? JSON.stringify(this.props.objectData.tourist_tax_parameters)
      : this.props.objectData.tourist_tax_parameters;
    return (
      <fieldset>
        <CountrySelector value={ this.props.objectData.country.value[1] } onChange={ this.handleChangeRelation.bind(this, 'country') } />
        <MultilingualField
          label="Name"
          name="name"
          value={ (this.props.objectData.name || {}).$i18n }
          onChange={ this.handleChangeLocalized.bind(this, 'name') }
          availableLocales={ this.props.availableLanguages }
        />
        <DropdownSelector
          label="Tourist tax type"
          name="tourist_tax_type"
          value={ this.props.objectData.tourist_tax_type }
          options={ touristTaxTypes.map(type => ({ name: type, value: type })) }
          onChange={ this.handleChange.bind(this, 'tourist_tax_type') }
        />
        {
          this.props.objectData.tourist_tax_type
            ? <CodeEditor
                label="Tourist tax parameters"
                name="tourist_tax_parameters"
                value={ touristTaxParameters || '' }
                onChange={ this.handleChange.bind(this, 'tourist_tax_parameters') }
                mode="javascript"
              />
            : null
        }
      </fieldset>
    );
  }
  handleChange(attributeName, field) {
    const { name, value } = field;
    this.props.updateEditedObject({ attributeName, value });
  }
  handleChangeLocalized(attributeName, field) {
    const { name, value } = field;
    this.handleChange(attributeName, { value: { $i18n: value } });
  }
  handleChangeRelation(attributeName, field) {
    const { name, value } = field;
    const reference = { ...this.props.objectData[attributeName] };
    reference.value[1] = value;
    this.handleChange(attributeName, { value: reference });
  }
}

Form.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
  updateEditedObject: React.PropTypes.func,
  availableLanguages: React.PropTypes.array,
};

export default HyperdbForm(Form, {
  namespace: 'zone',
  mountedUrl: '/zones',
  titleNew: 'Create new zone',
  titleEdit: 'Edit zone',
  displayName: (object) => object.name,
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/zone/containers/Form.jsx